import { Link } from 'react-router-dom';

import strings from 'lang/lang';
import { ReactComponent as ArrowRight } from 'styles/icon/arrowRight.svg';

function PlatformLinks() {
  return (
    <ul>
      <li>
        <a href="https://staq.io/platform" target="_blank"><span>{strings.footerList.text.features}</span><ArrowRight /></a>
      </li>
      <li>
        <Link to="/"><span>{strings.footerList.text.devPortal}</span><ArrowRight /></Link>
      </li>
      <li>
        <Link to="/docs/sdks/kyc"><span>{strings.footerList.text.SDK}</span><ArrowRight /></Link>
      </li>
      <li>
        <a href="/" target="_blank"><span>{strings.footerList.text.docs}</span><ArrowRight /></a>
      </li>
    </ul>
  );
}

export default PlatformLinks;